export const TRANCHE_COMPONENTS = {
    'active': {
        search: {
            permissions: [
                { permission_code: "VIEW_ACTIVE_TRANCHE_SEARCH" }
            ],
        },
        filters: {
            permissions: [
                { permission_code: "VIEW_ACTIVE_TRANCHE_FILTERS" }
            ],
        },
        download: { permissions: [{ permission_code: "VIEW_ACTIVE_TRANCHE_DOWNLOAD" }] },
    },
    'closed': {
        search: {
            permissions: [
                { permission_code: "VIEW_CLOSED_TRANCHE_SEARCH" }
            ],
        },
        filters: {
            permissions: [
                { permission_code: "VIEW_CLOSED_TRANCHE_FILTERS" }
            ],
        },
        download: { permissions: [{ permission_code: "VIEW_CLOSED_TRANCHE_DOWNLOAD" }] },
    },
    'pending-disbursal': {
        search: {
            permissions: [
                { permission_code: "VIEW_PENDING_DISBURSAL_TRANCHE_SEARCH" }
            ],
        },
        filters: {
            permissions: [
                { permission_code: "VIEW_PENDING_DISBURSAL_TRANCHE_FILTERS" }
            ],
        },
        download: { permissions: [{ permission_code: "VIEW_PENDING_DISBURSAL_TRANCHE_DOWNLOAD" }] },
    },
    'pending-approval': {
        search: {
            permissions: [
                { permission_code: "VIEW_PENDING_APPROVAL_TRANCHE_SEARCH" }
            ],
        },
        filters: {
            permissions: [
                { permission_code: "VIEW_PENDING_APPROVAL_TRANCHE_FILTERS" }
            ],
        },
        download: { permissions: [{ permission_code: "VIEW_PENDING_APPROVAL_TRANCHE_DOWNLOAD" }] },
    },
};


export const ACTIVE_TRANCHE_FILTERS = [
    { key: 'from_date', label: 'Requested Start Date', type: 'date' },
    { key: 'to_date', label: 'Requested End Date', type: 'date' },
    { key: 'min_amount', label: 'Minimum Amount', type: 'number' },
    { key: 'max_amount', label: 'Maximum Amount', type: 'number' },
    { key: 'tranche_id', label: 'Tranche ID', type: 'text' },
    // { key: 'loan_id', label: 'Loan ID', type: 'text' },
    { key: 'supplier_gst', label: 'Supplier GST', type: 'text' },
    { key: 'branch_code', label: 'Branch', type: 'multiselect' },
    { key: 'ro_id', label: 'RO Name', type: 'multiselect' },
    // { key: 'is_active', label: 'Active Status', type: 'select',
    //     options: [
    //         { label: "Yes", value: "true" },
    //         { label: "No", value: "false" },
    //     ]
    // },
    // { key: 'is_phone_verified', label: 'Phone Verification Status', type: 'select',
    //     options: [
    //         { label: "Yes", value: "true" },
    //         { label: "No", value: "false" },
    //     ]
    // },
];

export const CLOSED_TRANCHE_FILTERS = [
    { key: 'from_date', label: 'Requested Start Date', type: 'date' },
    { key: 'to_date', label: 'Requested End Date', type: 'date' },
    { key: 'min_amount', label: 'Minimum Amount', type: 'number' },
    { key: 'max_amount', label: 'Maximum Amount', type: 'number' },
    { key: 'tranche_id', label: 'Tranche ID', type: 'text' },
    // { key: 'loan_id', label: 'Loan ID', type: 'text' },
    { key: 'supplier_gst', label: 'Supplier GST', type: 'text' },
    { key: 'branch_code', label: 'Branch', type: 'multiselect' },
    { key: 'ro_id', label: 'RO Name', type: 'multiselect' },
    // { key: 'is_active', label: 'Active Status', type: 'select',
    //     options: [
    //         { label: "Yes", value: "true" },
    //         { label: "No", value: "false" },
    //     ]
    // },
    // { key: 'is_phone_verified', label: 'Phone Verification Status', type: 'select',
    //     options: [
    //         { label: "Yes", value: "true" },
    //         { label: "No", value: "false" },
    //     ]
    // },
];

export const PENDING_DISBURSAL_TRANCHE_FILTERS = [
    { key: 'from_date', label: 'Requested Start Date', type: 'date' },
    { key: 'to_date', label: 'Requested End Date', type: 'date' },
    { key: 'min_amount', label: 'Minimum Amount', type: 'number' },
    { key: 'max_amount', label: 'Maximum Amount', type: 'number' },
    { key: 'tranche_id', label: 'Tranche ID', type: 'text' },
    // { key: 'loan_id', label: 'Loan ID', type: 'text' },
    { key: 'supplier_gst', label: 'Supplier GST', type: 'text' },
    { key: 'branch_code', label: 'Branch', type: 'multiselect' },
    { key: 'ro_id', label: 'RO Name', type: 'multiselect' },
    // { key: 'is_active', label: 'Active Status', type: 'select',
    //     options: [
    //         { label: "Yes", value: "true" },
    //         { label: "No", value: "false" },
    //     ]
    // },
    // { key: 'is_phone_verified', label: 'Phone Verification Status', type: 'select',
    //     options: [
    //         { label: "Yes", value: "true" },
    //         { label: "No", value: "false" },
    //     ]
    // },
];

export const PENDING_APPROVAL_TRANCHE_FILTERS = [
    { key: 'from_date', label: 'Requested Start Date', type: 'date' },
    { key: 'to_date', label: 'Requested End Date', type: 'date' },
    { key: 'min_amount', label: 'Minimum Amount', type: 'number' },
    { key: 'max_amount', label: 'Maximum Amount', type: 'number' },
    { key: 'tranche_id', label: 'Tranche ID', type: 'text' },
    // { key: 'loan_id', label: 'Loan ID', type: 'text' },
    { key: 'supplier_gst', label: 'Supplier GST', type: 'text' },
    { key: 'branch_code', label: 'Branch', type: 'multiselect' },
    { key: 'ro_id', label: 'RO Name', type: 'multiselect' },
    // { key: 'is_active', label: 'Active Status', type: 'select',
    //     options: [
    //         { label: "Yes", value: "true" },
    //         { label: "No", value: "false" },
    //     ]
    // },
    // { key: 'is_phone_verified', label: 'Phone Verification Status', type: 'select',
    //     options: [
    //         { label: "Yes", value: "true" },
    //         { label: "No", value: "false" },
    //     ]
    // },
];